import { z } from 'zod'

export const NETSUITE_MAPPING_SOURCES = ['backfill', 'suiteql', 'manual'] as const
export type NetsuiteMappingSource = (typeof NETSUITE_MAPPING_SOURCES)[number]

export const NetsuiteProductMappingSchema = z.object({
  variantId: z.string().uuid(),
  externalId: z.string().min(1),
  internalId: z.string().nullable(),
  itemType: z.string().nullable(),
  isActive: z.boolean(),
  source: z.enum(NETSUITE_MAPPING_SOURCES),
})
export type NetsuiteProductMapping = z.infer<typeof NetsuiteProductMappingSchema>

export const NetsuiteProductMappingQuerySchema = z.object({
  activeOnly: z.coerce.boolean().optional().default(false),
})
export type NetsuiteProductMappingQuery = z.infer<typeof NetsuiteProductMappingQuerySchema>

export const NetsuiteProductMappingListResponseSchema = z.object({
  data: z.array(NetsuiteProductMappingSchema),
})
export type NetsuiteProductMappingListResponse = z.infer<typeof NetsuiteProductMappingListResponseSchema>
